export const AUTHORIZED_MODULE = 'AUTHORIZED';
export const SYSTEM_MODULE = 'SYSTEM';
export const GUEST_MODULE = 'GUEST';
export const USER_MODULE = 'USER';
export const NOTIFICATION = 'NOTIFICATION';
export const DASHBOARD_MODULE = 'DASHBOARD_MODULE';
export const APPLICATION_MODULE = 'APPLICATION_MODULE';
export const REFERENCE_INFORMATION_MODULE = 'REFERENCE_INFORMATION_MODULE';
export const REGION_REGISTRY_MODULE = 'REGION_REGISTRY_MODULE';
export const INTEGRATION_MODULE = 'INTEGRATION_MODULE';
export const WEB_SOCKET_MODULE = 'WEB_SOCKET_MODULE';
export const REPORT_MODULE = 'REPORT_MODULE';
export const SETTINGS_MODULE = 'SETTINGS_MODULE';
export const WAY_BILL_MODULE = 'WAY_BILL_MODULE';
export const VISITS_MODULE = 'VISIT_MODULE';
export const VEHICLES_REGISTRY_MODULE = 'VEHICLES_REGISTRY_MODULE';
export const DRIVER_LOG_MODULE = 'DRIVER_LOG_MODULE';
export const VIOLATIONS_MODULE = 'VIOLATIONS_MODULE';
export const INFORMATION_SCREEN_WRAPPER = 'INFORMATION_SCREEN_WRAPPER_MODULE';
export const CENTRIFUGE_MODULE = 'CENTRIFUGE_MODULE';
export const FILTER_TEMPLATE_MODULE = 'FILTER_TEMPLATE_MODULE';
export const ROLLBACK_VERSION_MODULE = 'ROLLBACK_VERSION_MODULE';
export const APPLICANT_MODULE = 'APPLICANT_MODULE';
export const INFORMATION_LOG_MODULE = 'INFORMATION_LOG_MODULE';
